import { useEffect, useCallback } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

const CONFIG = process.env.CONFIG

const TestBot = () => {
  const { embed_token } = useParams()
  const [query] = useSearchParams()
  const flowId = query.get('flow_id')

  const installWidget = useCallback(() => {
    window.HFBOT_CONFIG = {
      EMBED_TOKEN: embed_token,
      HF_LOG_LEVEL: 'DEBUG',
      options: {
        showBadge: true,
        isDraftMode: true,
        flowId
      },
      onLoad: (sdk, data) => {
        document.title = data.name + ' | ' + document.title
        window.HappyFoxBot = sdk
      }
    }
    const scriptTag = document.createElement('script')
    scriptTag.type = 'text/javascript'
    scriptTag.async = true
    scriptTag.defer = true
    scriptTag.src = `${new URL('/js/widget-loader.js', CONFIG.WIDGET_ASSET_URL).href}`
    const e = document.body || document.head
    e.appendChild(scriptTag)
  }, [embed_token, flowId])

  useEffect(() => {
    installWidget()
  }, [installWidget])

  return null
}

export default TestBot
